import { render, staticRenderFns } from "./blob_header.vue?vue&type=template&id=64c435e8"
import script from "./blob_header.vue?vue&type=script&lang=js"
export * from "./blob_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports